import { render, staticRenderFns } from "./workflowManage.vue?vue&type=template&id=9cc3ca84&scoped=true&"
import script from "./workflowManage.vue?vue&type=script&lang=js&"
export * from "./workflowManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc3ca84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cc3ca84')) {
      api.createRecord('9cc3ca84', component.options)
    } else {
      api.reload('9cc3ca84', component.options)
    }
    module.hot.accept("./workflowManage.vue?vue&type=template&id=9cc3ca84&scoped=true&", function () {
      api.rerender('9cc3ca84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/workflow/workflowManage/workflowManage.vue"
export default component.exports